import { createFileRoute } from "@tanstack/react-router";

import ComingSoonCover from "@/components/ComingSoonCover";

export const Route = createFileRoute(
  "/_staff/software/_layout/contract-and-cost/",
)({
  component: ComingSoonCover,
});
